import { FunctionComponent as FC } from "preact";

type IframeProps = {
    url: string;
};

const Iframe: FC<IframeProps> = ({ url }) => {
    return (
        <iframe
            width="100%"
            height="100%"
            allowFullScreen
            frameBorder={0}
            src={url}
        ></iframe>
    );
};

export default Iframe;
